import { useMemo } from "react";

type Props = {
	// 名称
	name: string;
	// キャンセル料金
	canceledPrice: number;
};

export const PrintDeadItemTBodyLayout = ({ name, canceledPrice }: Props) => {
	const canceledPriceText = useMemo(() => `¥ ${canceledPrice.toLocaleString()}`, [canceledPrice]);

	return (
		<div className="grid grid-cols-12">
			<div className="col-span-2 border border-zinc-200 p-1">
				<p>キャンセル料金</p>
			</div>
			<div className="col-span-8 border border-zinc-200 p-1">
				<p>{name}</p>
			</div>
			<div className="col-span-2 border border-zinc-200 p-1 text-right">
				<p>{canceledPriceText}</p>
			</div>
		</div>
	);
};
